module.exports = "/_next/static/images/SendTheData@2x-80d5cd6706dec95834bcdeebadae4731.webp";